import React, { useState, useEffect } from "react";
import ReactTable from "react-table-6";

import "react-table.css";

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
} from "@material-ui/core";

//color
import Colors from "shared/color";

//scss
import "./scss/table.scss";

//Component
import TableBodyCell from "./TableBodyCell";
import { Grid } from '@material-ui/core';
import { Pagination } from "@material-ui/lab";

// import Table from "./Table";
const useStyles = makeStyles((theme) => ({
  table: {
    // minWidth: "650px",

    "& tbody:nth-child(even)": {
      backgroundColor: Colors["lighterPurple"],
    },
    "& .MuiTableCell-head": {
      lineHeight: "1rem ",
      textTransform: "capitalize",
    },
    "& .MuiTableCell-root": {
      lineHeight: "1.2",
      position: "relative",
      "& .rt-resizer": {
        display: "none",
      },

      // maxWidth:"10.8vw",
    },
  },
}));

const KisshtTable = ({ showPagination, pageSize = 20, ...props }) => {
  const classes = useStyles();
  const [customPage, setcustomPage] = useState(props.offset || 1);
  const list = props.data;
  useEffect(() => {
    setcustomPage(props.offset || 1);
  }, [props.offset]);
  return (
    list && (
      <ReactTable
        resized={[]}
        minRows={0}
        filterable={false}
        style={{ border: "none" }}
        showPaginationTop={true}
        showPaginationBottom={false}
        showPagination={showPagination}
        pageSize={pageSize}
        PaginationComponent={(props) => {
          const { pageSize, pages } = props;
          let currentPage = customPage;
          let from = currentPage === 1 ? 1 : (currentPage - 1) * pageSize + 1;
          let to = currentPage * pageSize;
          let totalData = props.totalCount
            ? props.totalCount
            : props.sortedData.length;
          return totalData ? (
            <Grid container direction="row" className="text-xs pagination-text _pagination_mobile">
              <Grid item  lg={7} md={7} sm={6} xs={12} className="mobile_space_pagination" style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center'
              }}>
              <span
                style={{
                  color: Colors["lightPurple"]
                }}
              >{`Showing result from ${from} to ${totalData < to ? totalData : to
                } out of ${totalData}`}</span>
              </Grid>
              <Grid item lg={5} md={5} sm={6} xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Pagination
                className="pagination_style"
                onChange={(e, page) => {
                  setcustomPage(page);
                  if (!props.offset) {
                    props.onPageChange(page - 1);
                  } else {
                    props.onPageChange(page);
                  }
                }}
                page={currentPage}
                count={
                  props.totalCount
                    ? Math.ceil(props.totalCount / pageSize)
                    : pages
                }
                hideNextButton={props.canNext}
                hidePrevButton={props.canPrevious}
                color="primary"
              />
              </Grid>
            </Grid>
            // <span className="text-xs pagination-text">
            //   <span
            //     style={{
            //       color: Colors["lightPurple"],
            //       margin: "auto",
            //       textAlign: "center",
            //     }}
            //   >{`Showing result from ${from} to ${totalData < to ? totalData : to
            //     } out of ${totalData}`}</span>
            //   <Pagination
            //     onChange={(e, page) => {
            //       setcustomPage(page);
            //       if (!props.offset) {
            //         props.onPageChange(page - 1);
            //       } else {
            //         props.onPageChange(page);
            //       }
            //     }}
            //     page={currentPage}
            //     count={
            //       props.totalCount
            //         ? Math.ceil(props.totalCount / pageSize)
            //         : pages
            //     }
            //     hideNextButton={props.canNext}
            //     hidePrevButton={props.canPrevious}
            //     color="primary"
            //   />
            // </span>
          ) : null;
        }}
        TableComponent={(props) => {
          return (
            list.length > 0 && (
              <TableContainer className="_commontable_mobile">
                <Table
                  size="small"
                  className={`${classes.table} common_table_font`}
                  aria-label="simple table"
                  
                >
                  {props.children}
                </Table>
              </TableContainer>
            )
          );
        }}
        TheadComponent={(props) => {
          return (
            <TableHead>
              <TableRow className="common_table_header">{props.children}</TableRow>
            </TableHead>
          );
        }}
        ThComponent={({ ...props }) => {
          return (
            <TableCell
              style={{
                border: `1px solid ${Colors["purlple_100"]}`,
                fontSize: "0.8125rem",
                padding: "10px",
                color: "#000000",
                whiteSpace: "break-spaces",
                fontFamily: "poppins-medium",
                ...props.style,
              }}
              className={`${props.className}`}
              onClick={props.toggleSort}
            >
              {props.children}
            </TableCell>
          );
        }}
        TrComponent={(props) => props.children}
        TbodyComponent={(props) => {
          return props.children;
        }}
        TrGroupComponent={(props) => {
          return <TableBody><TableRow>{props.children}</TableRow></TableBody>;
        }}
        TdComponent={(props) => {
          return <TableBodyCell style={{wordBreak:"break-word"}}>{props.children}</TableBodyCell>;
        }}
        {...props}
      />
    )
  );
};

export default KisshtTable;
